module.exports = __webpack_public_path__ + "media/images/application/template/icon-missing-a3759d287e3126c0f79d476739a24144.svg";